module.exports = __webpack_public_path__ + "static/img/12.705b073b.png";